<template>
  <div class="columns is-gapless" style="margin-bottom: 0;">
    <div class="column">
      <b-datetimepicker
        rounded
        :append-to-body="true"
        placeholder="Pilih Tangal dan Waktu"
        icon="calendar-today"
        :min-datetime="custom_min_datetime"
        :max-datetime="custom_max_datetime"
        :datepicker="{ showWeekNumber: false }"
        :timepicker="{ enableSeconds: false, hourFormat: '24' }"
        :position="position"
        v-model="custom_datetime"
      >
      </b-datetimepicker>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datetime: {
      type: String,
      default: null
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    min_datetime: {
      type: String || null || undefined,
      default: undefined,
    },
    max_datetime: {
      type: String || null || undefined,
      default: undefined,
    },
    position: {
      type: String,
      default: "is-bottom-right"
    }
  },

  computed: {
    custom_datetime: {
      get() {
        let date = moment();
        if (!this.isEmpty(this.datetime)) {
          date = moment(this.datetime);
        }

        return date.toDate();
      },
      set(val) {
        let datetime = moment(val).format('YYYY-MM-DD HH:mm:ss');
        this.onChange(datetime);
      }
    },
    custom_min_datetime() {
      let date = moment();
      if (!this.isEmpty(this.min_datetime)) {
        date = moment(this.min_datetime);
      } else if (this.min_datetime === null) {
        return null;
      }

      return date.toDate();
    },
    custom_max_datetime() {
      if (!this.isEmpty(this.max_datetime)) {
        return moment(this.max_datetime).toDate();
      }

      return null
    },
  },
}
</script>

<style scope>
  .datepicker {
    display: block !important;
  }
</style>
